import React from 'react';
import { useLocation } from "@reach/router";

type Props = {
  node: IStorageUnfilteredHtml;
};

const StorageUnfilteredHtml = ({ node }: Props) => {
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const utm_medium = params.get("utm_medium");

    // Hide Non Subscriber iframe
    if (node.drupal_id === '5cfbc0c2-98d8-44d3-a218-26034ed3f0d6' && utm_medium === "email") {
        return [];
    }

    // Hide Subscriber iframe
    if (node.drupal_id === 'f7848e2d-6360-4be7-b971-d16dfcd48f6a' && !utm_medium) {
        return [];
    }

  return (
    <div
      data-id={node.drupal_id}
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: node.field_unfiltered_html.processed }}
    />
  );
};

export default StorageUnfilteredHtml;
